import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PenIcon } from '../../appearence/icons/pen_icon';
import { preferencesStorageInstance as preferencesStorage } from '../../services/preferencesStorage';
import {IconWrapper} from "../../appearence/icons/icon_wrapper";

const PreferencesListActionsEditIcon = () => {
    const [isDisabled, setIsDisabled] = useState(true);
    const navigate = useNavigate();

    const changeIsDisabled = () => {
        setIsDisabled(preferencesStorage.getSelectedPreferencesList().length !== 1);
    };

    useEffect(() => {
        preferencesStorage.registerFiltersChangingObserver(changeIsDisabled);
        return () => preferencesStorage.unRegisterFiltersChangingObserver(changeIsDisabled);
    }, []);

    const navigateOnEditPage = () => {
        if(!isDisabled) {
            navigate(`/preference/item/${preferencesStorage.getSelectedPreferencesList()[0].id}`);
        }
    };

    return (
        <li onClick={navigateOnEditPage}>
            <IconWrapper><PenIcon handleClick={navigateOnEditPage}/></IconWrapper>
        </li>
    );
};

export default PreferencesListActionsEditIcon;
